<template>
	<div>
		<div v-loading="loading" class="home_about" style="margin-top: 55px;">
			<div class="padding_xl_l flex" style="height: 100%;">
				<div class="left">
					<div class="left_box">
						<div class="con">
							<h1 class="title">关于我们</h1>
							<p class="text" v-html="infoData.remark"></p>
						</div>
						<HomeMoreBtn @click="handleMore" />
					</div>
				</div>

				<div class="right">
					<img class="img" :src="$http.fileUrl + infoData.about_pic" alt="">
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import HomeMoreBtn from "./moreBtn";
import {getAboutUsInfoApi} from "@/api";

export default {
	name: "index",
	components: {
		HomeMoreBtn,
	},
	data() {
		return {
			loading: false,
			infoData: {},
		}
	},
	created() {
		this.init();
	},
	methods: {
		async init() {
			this.loading = true;
			const res = await getAboutUsInfoApi();
			this.infoData = res.data && res.data[0] ? res.data[0] : {};
			this.infoData.remark = this.infoData.remark ? this.infoData.remark.replaceAll("\n", "<br>") : "";
			this.loading = false;
		},

		handleMore() {
			this.$router.push("/about");
		}
	}
}
</script>

<style lang="less" scoped>
.home_about {
	height: 385px;
	margin-top: 55px;
	background-color: #F1F4F9;
	overflow: hidden;

	.left {
		transition: all 1s;

		width: 50%;
		height: 100%;
		padding: 60px 40px 0 0;
		display: flex;
		justify-content: flex-end;
		overflow: hidden;
		transform: translateX(0);

		.left_box {
			width: 100%;
			max-width: calc(@conWidth / 2);
			height: 100%;
		}

		.title {
			font-size: 34px;
			color: @red;
		}

		.text {
			line-height: 1.6;
			margin-top: 10px;
			.ellipsis4;
		}
	}

	.right {
		transition: all 1s;
		transform: translateX(0);

		width: 50%;
		height: 100%;

		img {
			width: 100%;
			height: 100%;
			object-fit: cover;
		}
	}
}
</style>
